// extracted by mini-css-extract-plugin
export default {"container":"StackQuerySuggestions_container__RLG+-","title":"StackQuerySuggestions_title__xm5W-"};